import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// TODO Create another list needs to save then clear

export const NewItemListFooter = ({ setList, baseList }) => {
  return (
    <Flex>
      <Button type="submit">Finish list</Button>
      <Link to="/list/new">
        <Button onClick={() => setList(baseList)}>Create another list</Button>
      </Link>
    </Flex>
  );
};

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.button`
  background: none;
  border: none;
  font-size: 1rem;
  padding: 15px 20px;
  cursor: pointer;

  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
`;
